import Entity from '@/common-utils/components/renders/entity/Entity';
import Icon from '@/common-utils/components/renders/icon/Icon';
import ICONS from '@/common-utils/enums/icons';
import { Separator } from '@/common-utils/components/ui/separator';
import PropTypes from 'prop-types';
import { nsHistorics } from '@/app/i18n/namespaces';

/**
 *
 * @param {Object} props
 * @param {Object} props.initialPermissions
 * @param {Object} props.finalPermissions
 * @returns {JSX} RenderPermissionsHistorics
 */
function RenderPermissionsHistorics({ initialPermissions, finalPermissions }) {
    const added = finalPermissions ? finalPermissions.map((perm) => { if (initialPermissions.indexOf(perm) === -1) { return perm; } })
        .filter(item => item !== undefined) : [];

    const removed = initialPermissions ? initialPermissions.map((perm) => { if (finalPermissions.indexOf(perm) === -1) { return perm; } })
        .filter(item => item !== undefined) : [];

    const addedNumber = added.length;
    const removedNumber = removed.length;

    return (
        <div className='flex items-center gap-2'>
            {!addedNumber && !removedNumber
                && <Entity entity='cells.no_permission_modified' namespace={nsHistorics} className='italic' />
            }
            {addedNumber > 0 &&
                <span className='flex'>
                    <Icon icon={ICONS.ADD} className='text-success-foreground' />
                    {addedNumber}
                </span>
            }
            {addedNumber > 0 && removedNumber > 0 && <Separator orientation='vertical' className='h-4' />}
            {removedNumber > 0 &&
                <span className='flex'>
                    <Icon icon={ICONS.REMOVE} className='text-danger-foreground' />
                    {removedNumber}
                </span>
            }
        </div>
    );
}

RenderPermissionsHistorics.propTypes = {
    initialPermissions: PropTypes.array,
    finalPermissions: PropTypes.array
};

export default RenderPermissionsHistorics;